// src/components/UploadField.jsx
import React, { useState } from "react";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";

export default function UploadField({ pathPrefix = "colischine", onUploaded }) {
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);

  const onPick = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const ts = Date.now();
    const storageRef = ref(storage, `${pathPrefix}/${ts}-${file.name}`);
    const task = uploadBytesResumable(storageRef, file);
    setUploading(true);

    task.on(
      "state_changed",
      (snap) => {
        setProgress(Math.round((snap.bytesTransferred / snap.totalBytes) * 100));
      },
      (err) => {
        console.error(err);
        setUploading(false);
      },
      async () => {
        const url = await getDownloadURL(task.snapshot.ref);
        onUploaded?.(url);
        setUploading(false);
        setProgress(0);
      }
    );
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <input className="form-control" type="file" accept="image/*" onChange={onPick} />
      {uploading && <span className="small text-muted">{progress}%</span>}
    </div>
  );
}
